import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import LeaveApplyDetail from '../LeaveManagement/LeaveApplyDetail'
class VacationDeductionInfoDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'GetVacationDeductionInfo',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, initValues假期加扣明细, initValues给假明细 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, initValues假期加扣明细, initValues给假明细, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose, onSave } = this.props
        onClose && onClose()
        onSave && onSave()
    }

    fieldset假期加扣明细 = () => {
        return [
            {
                _grid: '', minWidth: '95%', name: '假期加扣明细', rowNumbers: true, /* minRows: 3, maxRows: 5, */ height: '100%',
                columns: [
                    { _text: '申请编号', flex: 2 },
                    { _text: '职务代理人', flex: 2 },
                    { _text: '请假时间', flex: 4 },
                    { _text: '请假时长', flex: 2 },
                    { _text: '请假原因', flex: 2 },
                ],
                buttons: [
                ],
                onDoubleTap: data => {
                    Tyan.pubForm.showDialog('', props => <LeaveApplyDetail {...props} id={data.id} readOnly={true} />)
                }
            }
        ]
    }

    fieldset给假明细 = () => {
        return [
            {
                _grid: '', minWidth: '95%', name: '给假明细', rowNumbers: true, /* minRows: 3, maxRows: 5, */ height: '100%',
                columns: [
                    { _date: '给假时间', flex: 1 },
                    { _text: '给假时长（H）', name: '给假时长', minWidth: 150, flex: 1 },
                ],
                buttons: [
                ]
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="900"
            controls={
                [
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fullForm={true}
            fieldsets={
                [
                    {
                        _fieldsets: [
                            { title: '请假明细', name: '假期加扣明细', _fieldset: this.fieldset假期加扣明细(), fullblock: true },
                            { title: '给假明细', name: '给假明细', _fieldset: this.fieldset给假明细(), fullblock: true }
                        ]
                    }
                ]}
        />
    }
}

export default connect()(VacationDeductionInfoDiv)